export default function () {
    const body = document.getElementsByTagName('BODY')[0];
    const backdrop = document.getElementById('backdrop');
    const mainmenu = document.querySelector('.c-navbar');
    const mainmenuPrev = document.getElementById('mainmenuPrev');
    const mainmenuTitle = document.getElementById('mainmenuTitle');
    const categoryMenuToggle = document.getElementById('togglecm');
    const toggleMainmenu = document.getElementById('toggleMainmenu');
    const mainmenuClose = document.getElementById('mainmenuClose');
    const checkoutCartToggle = document.getElementById('togglecheckoutcart');
    const addOrderToBasket = document.querySelectorAll('.addordertobasket');
    const toggleRelations = document.querySelectorAll('.c-topcollapse__btn');

    let mainmenuAct = null;
    let isTouchScreen = false;
    let menuLevel = 1;
    let clickEvent = 'click';

    (function () {
        if ('ontouchstart' in document.documentElement) {
            isTouchScreen = true;
        }
    })();

    if (isTouchScreen) {
        clickEvent = 'touchend';
    }

    if (backdrop != null) {
        backdrop.addEventListener(clickEvent, function () {
            body.classList.remove('open-categorymenu');
            body.classList.remove('open-filter');
            body.classList.remove('open-mainmenu');
            body.classList.remove('open-relations');
            categoryMenuToggle.parentElement.classList.remove('nav-open');
        });
    };

    document.addEventListener('click', function (event) {
        toggleNavLink(event);
        prevMainMenu(event);
    });

    if (toggleMainmenu != null) {
        toggleMainmenu.addEventListener('click', function (event) {
            event.preventDefault();
            body.classList.toggle('open-mainmenu');
        });
    }

    if (addOrderToBasket != null) {
        addOrderToBasket.forEach(function (element) {
            element.addEventListener('click', async function (event) {
                event.stopPropagation();
                event.preventDefault();

                // do the trick
                const fetchPromise = await fetch('/api/winkelwagen/createbasketbyorder', {
                    method: 'POST',
                    body: JSON.stringify({ orderNumber: this.dataset.ordernumber }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const creationResponse = await fetchPromise.json();

                if (creationResponse !== null && creationResponse.IsSuccessfull === true) {
                    // do success animation
                    const item = event.target.parentNode.parentNode;
                    const topcart = document.getElementById('topcart');

                    if (item && topcart) {
                        item.classList.add('show-feedback');
                        topcart.classList.add('cart-changed');
                        setTimeout(function () {
                            item.classList.remove('show-feedback');
                            topcart.classList.remove('cart-changed');
                        }, 1500);
                    }

                    // update local storage (cart id and amount of items)
                    localStorage.setItem('basketId', creationResponse.BasketId);
                    window.dispatchEvent(new CustomEvent('aquaco-basket-changed', {
                        detail: {
                            amount: creationResponse.TotalAmount
                        }
                    }));
                }
            });
        });
    }

    if (mainmenuClose != null) {
        mainmenuClose.addEventListener('click', function (event) {
            event.preventDefault();
            body.classList.remove('open-mainmenu');
        });
    }

    if (categoryMenuToggle != null) {
        categoryMenuToggle.addEventListener('click', function (event) {
            event.preventDefault();
            event.target.parentElement.classList.toggle('nav-open');
            body.classList.toggle('open-categorymenu');
        });
    }


    if (toggleRelations != null) {
        toggleRelations.forEach(function (element) {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                body.classList.toggle('open-relations');
            });
        });
    }

    if (checkoutCartToggle != null) {
        checkoutCartToggle.addEventListener('click', function (event) {
            event.preventDefault();
            checkoutCartToggle.parentElement.parentElement.classList.toggle('cart-open');
        });
    }

    function toggleNavLink(event) {
        if (!event.target.matches('.nlt')) return;
        event.preventDefault();
        menuLevel++;
        event.target.parentElement.classList.add('show');
        mainmenu.setAttribute('data-menulevel', menuLevel);
        /* eslint-disable no-unused-vars */
        mainmenuAct = event.target.parentElement;
        /* eslint-enable no-unused-vars */

        if (mainmenuPrev != null) {
            mainmenuPrev.classList.add('show');
        }

        if (mainmenuTitle != null && event.target.previousElementSibling != null) {
            mainmenuTitle.innerHTML = getMainMenuTitle(event.target.previousElementSibling);
        }
    }

    function getMainMenuTitle(item) {
        if (item.href == null || item.innerText == null) return '';
        return '<a href=\'' + item.href + '\' title=\'' + item.innerText + '\'>' + item.innerText + '</a>';
    }

    function prevMainMenu(event) {
        if (!event.target.matches('#mainmenuPrev')) return;
        event.preventDefault();
        menuLevel--;
        mainmenuAct.classList.remove('show');
        mainmenu.setAttribute('data-menulevel', menuLevel);

        // Get parentNode
        var parentNode = null;
        if (mainmenuAct.parentElement != null && mainmenuAct.parentElement.parentElement != null) {
            const classlist = mainmenuAct.parentElement.parentElement.classList;
            const isnav = classlist.contains('nav-item');
            if (isnav) parentNode = mainmenuAct.parentElement.parentElement;
        }

        if (mainmenuPrev != null && parentNode == null) {
            mainmenuPrev.classList.remove('show');
        }

        // Set menuTitle
        if (mainmenuTitle != null && parentNode != null) {
            mainmenuTitle.innerHTML = getMainMenuTitle(parentNode.firstElementChild);
        } else {
            mainmenuTitle.innerHTML = '';
        }

        mainmenuAct = parentNode;
    }
}
